import { useGLTF, useTexture } from '@react-three/drei';
import { CharacterSkins, CharacterSlugs } from '../types/SharedTypes';

const characters = Object.values(CharacterSlugs);
const skins = Object.values(CharacterSkins);

characters.forEach(char => {
  useGLTF.preload(`/3d/${char}/scene.gltf`);
  skins.forEach(skin => {
    useTexture.preload(`/3d/${char}/textures/texture-${skin}.png`);
  });
});